import React from "react"

import ContentfulLongText from "../../ContentfulLongText"
import { TextMedia, TextMediaCenter } from "../../TextMedia"
import ContactForm from "../../ContactForm"
import { BlogTestimonial } from "../BlogTestimonial"

import "./blog-content.css"

export const BlogContent = ({ post }) => {
    let isVisible = post.hasContactForm || post.googleMapSettings || post.googleReviewsPosition
    let isRight = isVisible && ((post.contactFormPosition === 'Right') || (post.googleMapSettings && post.googleMapSettings.position === 'Right') || (post.googleReviews && post.googleReviewsPosition === 'Right'))
    let isBottom = isVisible && ((post.contactFormPosition === 'Bottom') || (post.googleMapSettings && post.googleMapSettings.position === 'Bottom') || (post.googleReviews && post.googleReviewsPosition === 'Bottom'))
    let colClass = isRight ? ' col-8-2' :' col-1'
    return (
        <div className={`blog-body-content mt-10 grid${colClass} col-1-lg`}>
            <div className={isRight ? 'pr-10':'pb-15'}>
                {post.blogBodyContent !== null && post.blogTemplate !== "Hero with Small Feature Image" ? <TextMedia content={post.blogBodyContent} /> : <TextMediaCenter content={post.blogBodyContent} hasContactForm={post.hasContactForm}  contactFormPosition={post.contactFormPosition} isVisible={isVisible} isRight={isRight} />}
                {post.outroTextStyling && (
                    <div className="my-10">
                        {post.blogTemplate !== "Hero with Small Feature Image" ? <ContentfulLongText longTextContent={post.outroTextStyling.content.content} styleVal={{ fontSize: `${post.outroTextStyling.fontSize}px`, lineHeight: `${post.outroTextStyling.lineHeight}px` }} /> 
                        :(<div className={`grid${isVisible ? (isRight ? ' col-1-5':' col-1-4-1'):' col-1-4-1'} col-1-md gap-10 gap-15-md`}>
                            <div></div>
                            <ContentfulLongText longTextContent={post.outroTextStyling.content.content} styleVal={{ fontSize: `${post.outroTextStyling.fontSize}px`, lineHeight: `${post.outroTextStyling.lineHeight}px` }} />
                            <div></div>
                        </div>)}
                        </div>
                )}
                {(isBottom)? (
                    <div className={`grid blog-features bottom col-1-md${post.blogTemplate !== "Hero with Small Feature Image" ?' col-1': isRight ? ' col-1-5' : ' col-1-4-1'}`}>
                        <div></div>
                        <div className="content">
                            {(post.googleMapSettings && post.googleMapSettings.position === 'Bottom') && <iframe src={`https://www.google.com/maps/embed?${post.googleMapSettings.googleMapEmbed.googleMapEmbed}`} height="450" style={{border:0}} className="iframe--maps" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>}
                            {(post.googleReviews && post.googleReviewsPosition === 'Bottom') && <BlogTestimonial postData={post} />}
                            {(post.hasContactForm && post.contactFormPosition === 'Bottom') && <ContactForm pageName={`${post.title} Blog`} languageVal={post.languagePreference} />}
                        </div>
                    </div>
                ):null}
            </div>
            {(isRight) ? (
                <div className="blog-features right">
                    {(post.hasContactForm && post.contactFormPosition === 'Right') && <ContactForm pageName={`${post.title} Blog`} languageVal={post.languagePreference} />}
                    {(post.googleMapSettings && post.googleMapSettings.position === 'Right') && <iframe src={`https://www.google.com/maps/embed?${post.googleMapSettings.googleMapEmbed.googleMapEmbed}`} height="450" style={{border:0}} className="iframe--maps" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>}
                    {(post.googleReviews && post.googleReviewsPosition === 'Right') && <BlogTestimonial postData={post} />}
                </div>
            ):null}
        </div>
    )
}

export default BlogContent
